import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '@/lib/analytics';

/**
 * Fires an anonymous page_view on every route change.
 * Must be rendered inside the router.
 */
export function AnalyticsTracker() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    trackEvent('page_view');
  }, [location.pathname]);

  return null;
}

export default AnalyticsTracker;
